import styled from "@emotion/styled";
import { Skeleton } from "@mui/material";

export const SkeletonWrapper = styled.div({
	display: "flex",
	gap: "20px",
	margin: "16px 32px",
	padding: "24px"
});

export const ImageSkeleton = styled(Skeleton)(({ theme }) => ({
	width: "500px",
	height: "432px",
	[theme.breakpoints.down("sm")]: {
		width: "200px"
	}
}));

export const SkeletonDetails = styled.div({
	display: "flex",
	flexDirection: "column",
	gap: "20px",
	width: "50%"
});
